"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepositsService = void 0;
const bitcoin_1 = require("../../lib/bitcoin");
const utils_1 = require("../../lib/utils");
const deposit_1 = require("./deposit");
const crypto = __importStar(require("crypto"));
/**
 * Service exposing features related to tBTC v2 deposits.
 */
class DepositsService {
    constructor(tbtcContracts, bitcoinClient) {
        /**
         * Deposit refund locktime duration in seconds.
         * This is 9 month in seconds assuming 1 month = 30 days
         */
        this.depositRefundLocktimeDuration = 23328000;
        this.tbtcContracts = tbtcContracts;
        this.bitcoinClient = bitcoinClient;
    }
    /**
     * Initiates the tBTC v2 deposit process.
     * @param bitcoinRecoveryAddress P2PKH or P2WPKH Bitcoin address that can
     *                               be used for emergency recovery of the
     *                               deposited funds.
     * @returns Handle to the initiated deposit process.
     * @throws Throws an error if one of the following occurs:
     *         - The default depositor is not set
     *         - There are no active wallet in the Bridge contract
     *         - The Bitcoin recovery address is not a valid P2(W)PKH
     */
    async initiateDeposit(bitcoinRecoveryAddress) {
        const receipt = await this.generateDepositReceipt(bitcoinRecoveryAddress);
        return deposit_1.Deposit.fromReceipt(receipt, this.tbtcContracts, this.bitcoinClient);
    }
    async generateDepositReceipt(bitcoinRecoveryAddress) {
        if (this.defaultDepositor === undefined) {
            throw new Error("Default depositor is not set; use setDefaultDepositor first");
        }
        const blindingFactor = utils_1.Hex.from(crypto.randomBytes(8));
        const walletPublicKey = await this.tbtcContracts.bridge.activeWalletPublicKey();
        if (!walletPublicKey) {
            throw new Error("Could not get active wallet public key");
        }
        const walletPublicKeyHash = bitcoin_1.BitcoinHashUtils.computeHash160(walletPublicKey);
        const bitcoinNetwork = await this.bitcoinClient.getNetwork();
        const recoveryOutputScript = bitcoin_1.BitcoinAddressConverter.addressToOutputScript(bitcoinRecoveryAddress, bitcoinNetwork);
        if (!bitcoin_1.BitcoinScriptUtils.isP2PKHScript(recoveryOutputScript) &&
            !bitcoin_1.BitcoinScriptUtils.isP2WPKHScript(recoveryOutputScript)) {
            throw new Error("Bitcoin recovery address must be P2PKH or P2WPKH");
        }
        const refundPublicKeyHash = bitcoin_1.BitcoinAddressConverter.addressToPublicKeyHash(bitcoinRecoveryAddress, bitcoinNetwork);
        const currentTimestamp = Math.floor(new Date().getTime() / 1000);
        const refundLocktime = bitcoin_1.BitcoinLocktimeUtils.calculateLocktime(currentTimestamp, this.depositRefundLocktimeDuration);
        return {
            depositor: this.defaultDepositor,
            blindingFactor,
            walletPublicKeyHash,
            refundPublicKeyHash,
            refundLocktime,
        };
    }
    // eslint-disable-next-line valid-jsdoc
    /**
     * Sets the default depositor used for deposits initiated by this service.
     * @param defaultDepositor Chain-specific identifier of the default depositor.
     * @dev Typically, there is no need to use this method when DepositsService
     *      is orchestrated automatically. However, there are some use cases
     *      where setting the default depositor explicitly may be useful.
     *      Make sure you know what you are doing while using this method.
     */
    setDefaultDepositor(defaultDepositor) {
        this.defaultDepositor = defaultDepositor;
    }
}
exports.DepositsService = DepositsService;
//# sourceMappingURL=deposits-service.js.map